import React from 'react'
import { Field } from 'formik'

import { TextField, TextArea, Checkbox } from '@/components/forms/formik'
import { Banner } from '@/components/banners/Banner'

const TouchOnChangeField = ({ name, ...props }) => {
  return (
    <Field name={name} {...props}>
      {({ field, form, meta }) => {
        const handleChange = (event) => {
          form.setFieldTouched(name, true, false)
          field.onChange(event)
        }
        return (
          <TextField
            field={{ ...field, onChange: handleChange }}
            form={form}
            meta={meta}
            {...props}
          />
        )
      }}
    </Field>
  )
}

export const ContactListDetailsPage = () => {
  return (
    <div className="field-stack">
      <TouchOnChangeField name="name" label="Name" autoFocus />
      <Field name="description" label="Description" component={TextArea} />
      <Banner warning header="DNC Compliance">
        <Field
          name="dnc_scrub_acknowledged"
          label="I confirm this list has been pre-scrubbed against national, state, and internal DNC registries and all contacts have provided all required prior written consent for automated outbound calls."
          component={Checkbox}
        />
      </Banner>
    </div>
  )
}
